export default __webpack_public_path__ + "static/media/black-card-icon.23296d5b.svg";